import { ImageTemplate } from "../template";
import { ImageProps } from "..";
import BackgroundParachute1x from "./background-parachute-1x.png";
import BackgroundParachute2x from "./background-parachute-2x.png";

export const BackgroundParachuteImage = ({
  width,
  height,
  highResolution,
  ...props
}: ImageProps): JSX.Element => {
  return (
    <div style={{ height, width }}>
      <ImageTemplate
        {...props}
        imgSrc={highResolution ? BackgroundParachute2x : BackgroundParachute1x}
      />
    </div>
  );
};
